import { useTheme } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';

import DiamondIcon from '~icons/knowz-iconify/diamond';

import { useTranslate } from '@tolgee/react';
import { NavListItemsType } from '@webclient/layouts/main/sections/header/types';

type Props = {
  navListItems: NavListItemsType;
};

export default function DesktopNav({ navListItems }: Props) {
  const { t } = useTranslate();
  const theme = useTheme();

  return (
    <Stack
      component={List}
      disablePadding
      direction="row"
    >
      {navListItems.map(({ label, defaultLabel, link }, index) => {
        return (
          <ListItem
            key={index}
            disableGutters
            disablePadding
            sx={{ p: { md: 3, xs: 0 } }}
          >
            <ListItemButton
              sx={{
                '&:hover': {
                  backgroundColor: 'transparent',
                },
              }}
              href={link}
              target="_blank"
              disableGutters
              disableRipple
            >
              <ListItemText
                sx={{ whiteSpace: 'nowrap' }}
                primaryTypographyProps={{
                  variant: 'textSm',
                  fontWeight: 500,
                  color: 'text.primary',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <DiamondIcon
                  fontSize="1em"
                  color={theme.palette.utility.gray700}
                />
                &nbsp;
                {t(label, defaultLabel)}
              </ListItemText>
            </ListItemButton>
          </ListItem>
        );
      })}
    </Stack>
  );
}
